import { Badge } from '@/components/ui/badge';
import { ReleaseNoteCategory, CATEGORY_LABELS } from '../types';
import { cn } from '@/lib/utils';

const CATEGORY_STYLES: Record<ReleaseNoteCategory, string> = {
  [ReleaseNoteCategory.Feature]:
    'bg-success/10 text-success border-success/30',
  [ReleaseNoteCategory.BugFix]: 'bg-destructive/10 text-destructive border-destructive/30',
  [ReleaseNoteCategory.Improvement]:
    'bg-info/10 text-info border-info/30',
  [ReleaseNoteCategory.Breaking]:
    'bg-warning/10 text-warning border-warning/30',
  [ReleaseNoteCategory.Other]: 'bg-muted text-muted-foreground border-border',
};

interface CategoryBadgeProps {
  category: ReleaseNoteCategory;
}

export function CategoryBadge({ category }: CategoryBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-medium', CATEGORY_STYLES[category])}
    >
      {CATEGORY_LABELS[category]}
    </Badge>
  );
}
